<mt-header></mt-header>

<main [@fadeAnimation]="getRouterOutletState(outlet)" class="main-view">
    <router-outlet #outlet="outlet"></router-outlet>
</main>

<mt-footer></mt-footer>
